import { createSearchParams } from 'react-router-dom';

import { type useUser } from '@/entities/user/model/user.store';

import { ROUTE_PATHS } from '@/shared/config/router/types';

import { ReactComponent as FeedIcon } from '@/assets/images/tab-feed.svg?react';
import { ReactComponent as PlaycoinIcon } from '@/assets/images/tab-main.svg?react';
import { ReactComponent as TasksIcon } from '@/assets/images/tab-tasks.svg?react';

import { type LinkButton, type NavbarRouteWithoutSlash } from '../types';
import { getVisitedTabIndicatorKey } from './getVisitedTabIndicatorKey';

export const createTabs = ({
  user,
  indicators,
  isNew,
  urlParams,
  t,
}: {
  user: ReturnType<typeof useUser>;
  indicators: Record<string, boolean>;
  isNew: boolean;
  urlParams: Record<string, Record<string, any>>;
  t: (key: string) => string;
}): LinkButton[] => {
  const newTasksCounter = user?.newTasksCounter;

  const links: LinkButton[] = [
    {
      pathname: ROUTE_PATHS.FEED,
      title: t('Feed'),
      Icon: FeedIcon,
      indicator:
        isNew &&
        indicators[
          getVisitedTabIndicatorKey(
            ROUTE_PATHS.FEED.substring(1) as NavbarRouteWithoutSlash
          )
        ],
    },
    {
      pathname: ROUTE_PATHS.MAIN,
      title: t('Categories'),
      Icon: PlaycoinIcon,
      indicator:
        isNew &&
        indicators[
          getVisitedTabIndicatorKey(
            ROUTE_PATHS.MAIN.substring(1) as NavbarRouteWithoutSlash
          )
        ],
    },
    {
      pathname: ROUTE_PATHS.TASKS,
      title: t('Gifts'),
      Icon: TasksIcon,
      indicator: newTasksCounter,
    },
  ];

  return links.map((link) => {
    const params = urlParams[link.pathname];
    return {
      ...link,
      params: params ? createSearchParams(params).toString() : undefined,
    };
  });
};
